<template>
  <div class="web_link_campaign">
    <div class="survey" v-if="survey">
      <figure class="survey-company-logo">
        <img :src="survey.account.logo_url" />
      </figure>
      <div class="powered text-center mb-5">
        <div>Powered by:</div>
        <a :href="ue_logo_link" target="_blank" title="Visit UserEvidence.com" alt="UserEvidence">
          <UELogo />
        </a>
      </div>

      <h1>{{ survey.survey.name }}</h1>
      <p v-html="survey.survey.weblink_landing_page_text"></p>
      <p v-html="survey.survey.promotion_text"></p>
      <div class="questions" ref="questions">
        <h5>
          <span>Your Information</span>
        </h5>
        <div class="question">
          <h2 class="big-question-number">1</h2>
          <div class="the_field">
            <TextInput
              v-model="recipient.first_name"
              name="first_name"
              placeholder="Frank"
              label="First Name"
              :validation="{ required: true }"
            />
          </div>
        </div>
        <div class="question">
          <h2 class="big-question-number">2</h2>
          <div class="the_field">
            <TextInput
              v-model="recipient.last_name"
              name="last_name"
              placeholder="Wright"
              label="Last Name"
              :validation="{ required: true }"
            />
          </div>
        </div>
        <div class="question">
          <h2 class="big-question-number">3</h2>
          <div class="the_field" :class="errors.email ? 'error' : null">
            <label>Email</label>
            <b-form-input v-model="recipient.email" placeholder="frank@wright.com" type="email" />
            <div class="message" v-if="errors.email">Invalid email address</div>
          </div>
        </div>
      </div>
      <div class="send_button">
        <b-button variant="primary" @click="takeSurvey()">{{ button_text }}</b-button>
      </div>
      <div class="closing">
        <p class="mb-4">
          If you have any questions, please reach out to
          <a class="ml-1" :href="`mailto:${survey.survey.reply_to_email}`">{{
            survey.survey.reply_to_email
          }}</a
          >.
        </p>
        <p>Thanks,</p>
        <div>
          {{ survey.survey.from_first_name }} {{ survey.survey.from_last_name }},<br />
          {{ survey.survey.from_title }}
        </div>
        <div>{{ survey.account.name }}</div>
      </div>

      <Footer />
    </div>
  </div>
</template>
<script lang="ts">
import axios from '@lib/apiClient'
import TextInput from '@app/components/TextInput.vue'
import UELogo from '@app/graphics/UELogo.vue'
import Footer from '@survey/components/Footer.vue'
import appsignal from '@lib/appsignal'

export default {
  components: { TextInput, UELogo, Footer },
  props: ['survey_token'],
  data() {
    return {
      survey: null,
      recipient: {
        email: null,
        first_name: null,
        last_name: null,
      },
      errors: {
        email: null,
      },
    }
  },
  computed: {
    ue_logo_link() {
      return `${process.env.VUE_APP_UE_WWW_URL}?utm_campaign=survey-taking-experience_logo`
    },
    button_text() {
      if (this.survey.survey.custom_button_text) {
        return this.survey.survey.custom_button_text
      }
      return this.survey.survey.skip_weblink_email ? 'Take survey' : 'Send survey'
    },
  },
  beforeMount() {
    axios.get(`/api/surveys/${this.survey_token}.json`).then((res) => {
      this.survey = res.data
    })
  },
  methods: {
    message(field) {
      return this.errors[field]
    },
    takeSurvey() {
      this.$zodValidator.validate().then((result) => {
        if (result) {
          axios
            .post('/api/recipients.json', {
              survey_token: this.survey_token,
              recipient: this.recipient,
            })
            .then((res) => {
              if (res.data.recipient)
                this.$router.push({ path: `/surveys/${res.data.recipient.token}` })
              else this.$router.push({ path: '/surveys/thanks' })
            })
            .catch((err) => {
              this.errors = err.response.data.errors

              appsignal.sendError(err, (span) => {
                span.setAction('PostRecipients')
                span.setNamespace('WebLinkSurvey')
                span.setParams({ survey_id: this.survey.id })
              })
            })
        }
      })
    },
  },
}
</script>
<style lang="sass" scoped>

.powered svg
  max-width: 120px
  max-height: 24px

.error
  color: red
p
  margin-bottom: 30px
.questions
  margin-bottom: 50px
.question
  margin: 0 0 26px
.send_button
  display: flex
  justify-content: flex-end
  margin-bottom: 20px
.closing
  margin-bottom: 150px
</style>
